import { useState, useEffect, useRef } from "react";
import "./App.css";
import {
  IconMail, IconPhone, IconLocation, IconLinkedIn, IconGithub,
  IconBriefcase, IconGradCap, IconCheck, IconArrowRight,
  IconMenu, IconClose,
  IconPython, IconDjango, IconMySQL, IconGit, IconVSCode, IconJS, IconHTML, IconCSS,
} from "./icons";

/* ══ DATA ══ */
const DATA = {
  name: "Praveen G",
  email: "gpraveenkrishnan35@gmail.com",
  phone: "8015643990",
  location: "Bangalore, India",
  linkedin: "https://www.linkedin.com/in/praveeng-profile/",
  github: "https://github.com/Praveen004",
  skills: [
    {
      title: "Programming",
      items: [
        { label: "Python",     Icon: IconPython },
        { label: "JavaScript", Icon: IconJS     },
      ],
    },
    {
      title: "Web Dev",
      items: [
        { label: "HTML",   Icon: IconHTML   },
        { label: "CSS",    Icon: IconCSS    },
        { label: "Django", Icon: IconDjango },
      ],
    },
    {
      title: "Database",
      items: [{ label: "MySQL", Icon: IconMySQL }],
    },
    {
      title: "Tools",
      items: [
        { label: "Git",     Icon: IconGit    },
        { label: "GitHub",  Icon: IconGithub },
        { label: "VS Code", Icon: IconVSCode },
      ],
    },
  ],
  internship: {
    role: "Web Development Intern",
    company: "AK Info Park Private Limited",
    location: "Kanyakumari, India",
    period: "June 2024 – July 2024",
    points: [
      "Developed a fully functional Online Food Ordering System with 8+ core features.",
      "Designed a mobile-first responsive UI optimised for desktop, tablet, and mobile.",
      "Implemented dynamic menu rendering and real-time price updates.",
      "Built reusable UI components to improve performance.",
    ],
  },
  projects: [
    {
      title: "AI-Powered Document Chatbot",
      desc: "AI chatbot that answers questions from uploaded documents using RAG architecture.",
      features: ["PDF, DOCX, TXT uploads", "RAG Architecture", "70% faster document search"],
      tech: ["Python", "NLP", "AI Models", "Document Processing"],
      num: "01",
    },
    {
      title: "Forgery Signature Detection",
      desc: "Deep learning model using CNN to classify signatures as genuine or forged.",
      features: ["CNN-based detection", "Image preprocessing", "Genuine/Forged classification"],
      tech: ["Python", "Deep Learning", "CNN", "Image Processing"],
      num: "02",
    },
    {
      title: "Online Food Ordering System",
      desc: "Full-stack food ordering platform with responsive UI and dynamic features.",
      features: ["8+ core features", "Mobile-first design", "Real-time price updates"],
      tech: ["HTML", "CSS", "JavaScript", "Django"],
      num: "03",
    },
  ],
  education: [
    { degree: "B.E – Computer Science & Engineering", school: "Adhiyamaan College of Engineering",       location: "Hosur, India",  period: "2021 – 2025", score: "CGPA: 7.4"       },
    { degree: "Higher Secondary (HSC)",               school: "Ponjesly Public Higher Secondary School", location: "Kanyakumari",   period: "2020 – 2021", score: "85%" },
    { degree: "SSLC",                                 school: "Evans Matric Higher Secondary School",    location: "Kanyakumari",   period: "2018 – 2019", score: "78%"       },
  ],
  certifications: ["Web Development using Angular", "Cyber Security", "Web Development", "Python Full Stack Development"],
  course: {
    name: "Python Full Stack Development",
    org: "Pumo Tech",
    period: "Aug 2024 – Dec 2024",
    topics: ["Frontend & Backend Development", "CRUD Operations", "Form Handling", "Database Integration"],
  },
};

const NAV    = ["Home", "About", "Skills", "Internship", "Projects", "Education", "Contact"];
const TITLES = ["Python Developer", "Full Stack Developer", "Django Developer"];

/* ── Intro Roles for video overlay ── */
const INTRO_ROLES = [
  "Software Development",
  "Python Developer",
  "Full Stack Developer",
  "Data Engineer",
];

const CODE_LINES = [
  { text: "class Praveen:",                   color: "#C8533A" },
  { text: '    name = "Praveen G"',           color: "#e2c9b0" },
  { text: '    role = "Full Stack Dev"',      color: "#e2c9b0" },
  { text: "",                                 color: ""        },
  { text: "    def skills(self):",            color: "#C8533A" },
  { text: '        return ["Python",',        color: "#a8c5a0" },
  { text: '                "Django",',        color: "#a8c5a0" },
  { text: '                "React","MySQL"]', color: "#a8c5a0" },
  { text: "",                                 color: ""        },
  { text: "    def build(self, idea):",       color: "#C8533A" },
  { text: "        code = self.write(idea)",  color: "#c8c0b8" },
  { text: "        test = self.debug(code)",  color: "#c8c0b8" },
  { text: "        return self.ship(test)",   color: "#86c4a0" },
  { text: "",                                 color: ""        },
  { text: "dev = Praveen()",                  color: "#c8c0b8" },
  { text: 'dev.build("portfolio")',           color: "#a8c5a0" },
];

/* ── Coding Animation ── */
function CodingAnimation() {
  const [visible, setVisible] = useState(0);
  const [chars,   setChars]   = useState(0);
  const [done,    setDone]    = useState(false);

  useEffect(() => {
    if (done) {
      const t = setTimeout(() => { setVisible(0); setChars(0); setDone(false); }, 3000);
      return () => clearTimeout(t);
    }
    if (visible >= CODE_LINES.length) { setDone(true); return; }
    const line = CODE_LINES[visible].text;
    if (chars < line.length) {
      const t = setTimeout(() => setChars(c => c + 1), 38);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => { setVisible(v => v + 1); setChars(0); }, line === "" ? 80 : 180);
    return () => clearTimeout(t);
  }, [visible, chars, done]);

  return (
    <div className="editor-frame">
      <div className="editor-titlebar">
        <span className="e-dot e-red" />
        <span className="e-dot e-yellow" />
        <span className="e-dot e-green" />
        <span className="editor-fname">praveen.py</span>
      </div>
      <div className="editor-body">
        {CODE_LINES.slice(0, visible).map((l, i) => (
          <div key={i} className="c-line">
            <span className="c-num">{i + 1}</span>
            <span className="c-text" style={{ color: l.color || "#c8c0b8" }}>{l.text}</span>
          </div>
        ))}
        {visible < CODE_LINES.length && (
          <div className="c-line">
            <span className="c-num">{visible + 1}</span>
            <span className="c-text" style={{ color: CODE_LINES[visible].color || "#c8c0b8" }}>
              {CODE_LINES[visible].text.slice(0, chars)}<span className="c-cur" />
            </span>
          </div>
        )}
      </div>
      <div className="editor-foot">
        <span>Python</span><span>UTF-8</span>
        <span>Ln {Math.min(visible + 1, CODE_LINES.length)}</span>
      </div>
    </div>
  );
}

/* ── Intro Video Screen ── */
function IntroScreen({ onFinish }) {
  const videoRef      = useRef(null);
  const finishedRef   = useRef(false);
  const [started,     setStarted]    = useState(false); // false = splash, true = video playing
  const [roleIdx,     setRoleIdx]    = useState(0);
  const [progress,    setProgress]   = useState(0);
  const [fadeOut,     setFadeOut]    = useState(false);
  const [roleVisible, setRoleVisible] = useState(true);

  /* Role cycling every 2.5 s (only once video has started) */
  useEffect(() => {
    if (!started) return;
    const iv = setInterval(() => {
      setRoleVisible(false);
      setTimeout(() => {
        setRoleIdx(p => (p + 1) % INTRO_ROLES.length);
        setRoleVisible(true);
      }, 400);
    }, 2500);
    return () => clearInterval(iv);
  }, [started]);

  const handleFinish = () => {
    if (finishedRef.current) return;
    finishedRef.current = true;
    setFadeOut(true);
    setTimeout(() => onFinish(), 700);
  };

  /* Called when user clicks the splash screen — plays video WITH audio */
  const handleStart = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = false;
    video.play().catch(() => {
      /* If browser still blocks audio, play muted as last resort */
      video.muted = true;
      video.play().catch(() => {});
    });
    setStarted(true);
  };

  /* Track progress once video is playing */
  useEffect(() => {
    if (!started) return;
    const video = videoRef.current;
    if (!video) return;

    const onTime = () => {
      const dur = video.duration || 10;
      setProgress((video.currentTime / dur) * 100);
      if (video.currentTime >= Math.min(dur, 10)) handleFinish();
    };
    video.addEventListener("timeupdate", onTime);
    const fallback = setTimeout(() => handleFinish(), 10500);
    return () => {
      video.removeEventListener("timeupdate", onTime);
      clearTimeout(fallback);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [started]);

  return (
    <div className={`intro-screen${fadeOut ? " intro-fade-out" : ""}`}>

      {/* Video element — preloaded, but play() only called after user click */}
      <video
        ref={videoRef}
        className="intro-video"
        src="/Praveen_intro.mp4"
        playsInline
        preload="auto"
      />

      {/* Dark gradient overlay */}
      <div className="intro-overlay" />

      {/* ── SPLASH — shown before user clicks ── */}
      {!started && (
        <div className="intro-splash" onClick={handleStart}>
          <div className="intro-text-panel">
            <p className="intro-greeting">Hello, I'm</p>
            <h1 className="intro-name">Praveen G</h1>
            <p className="intro-splash-sub">Software Developer · Python · Full Stack · Data Engineer</p>
          </div>
          <div className="splash-play-btn">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="5 3 19 12 5 21 5 3"/>
            </svg>
          </div>
          <p className="splash-hint">Click anywhere to watch intro with sound</p>
        </div>
      )}

      {/* ── VIDEO PLAYING — shown after user clicks ── */}
      {started && (
        <>
          {/* Left text panel with role cycling */}
          <div className="intro-text-panel">
            <p className="intro-greeting">Hello, I'm</p>
            <h1 className="intro-name">Praveen G</h1>
            <div className={`intro-role-wrap${roleVisible ? " role-in" : " role-out"}`}>
              <span className="intro-role-badge">{INTRO_ROLES[roleIdx]}</span>
            </div>
            <div className="intro-role-dots">
              {INTRO_ROLES.map((_, i) => (
                <span key={i} className={`intro-dot${i === roleIdx ? " active" : ""}`} />
              ))}
            </div>
          </div>

          {/* Progress bar */}
          <div className="intro-progress-bar">
            <div className="intro-progress-fill" style={{ width: `${progress}%` }} />
          </div>

          {/* View Portfolio skip button */}
          <button className="intro-skip-btn" onClick={handleFinish}>
            View Portfolio
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
        </>
      )}

    </div>
  );
}

/* ── Icons ── */
const IcoDownload = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

/* ══ APP ══ */
export default function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [active,   setActive]   = useState("Home");
  const [menuOpen, setMenu]     = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [typed,    setTyped]    = useState("");
  const tiRef = useRef(0), ciRef = useRef(0), delRef = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
      let cur = "Home";
      NAV.forEach(n => {
        const el = document.getElementById(n.toLowerCase());
        if (el && window.scrollY >= el.offsetTop - 100) cur = n;
      });
      setActive(cur);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    let t;
    const tick = () => {
      const cur = TITLES[tiRef.current];
      if (!delRef.current) {
        setTyped(cur.slice(0, ciRef.current + 1));
        ciRef.current++;
        if (ciRef.current === cur.length) { delRef.current = true; t = setTimeout(tick, 1400); return; }
      } else {
        setTyped(cur.slice(0, ciRef.current - 1));
        ciRef.current--;
        if (ciRef.current === 0) { delRef.current = false; tiRef.current = (tiRef.current + 1) % TITLES.length; }
      }
      t = setTimeout(tick, delRef.current ? 55 : 90);
    };
    t = setTimeout(tick, 600);
    return () => clearTimeout(t);
  }, []);

  const scrollTo = s => {
    document.getElementById(s.toLowerCase())?.scrollIntoView({ behavior: "smooth" });
    setMenu(false);
  };

  /* Show intro screen first */
  if (showIntro) {
    return <IntroScreen onFinish={() => setShowIntro(false)} />;
  }

  return (
    <div>
      {/* NAVBAR */}
      <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
        <div className="nav-logo" onClick={() => scrollTo("home")}>
          <span className="logo-box">PG</span>
          <span className="logo-name">Praveen G.</span>
        </div>
        <ul className="nav-links">
          {NAV.map(n => (
            <li key={n} className={`nav-link${active === n ? " active" : ""}`} onClick={() => scrollTo(n)}>{n}</li>
          ))}
        </ul>
        <div className="nav-right">
          <a className="nav-cta" href={`mailto:${DATA.email}`}>Hire Me</a>
          <button className="menu-btn" onClick={() => setMenu(!menuOpen)} aria-label="Menu">
            {menuOpen ? <IconClose size={20} /> : <IconMenu size={20} />}
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="mobile-menu">
          {NAV.map(n => (
            <div key={n} className={`mobile-link${active === n ? " active" : ""}`} onClick={() => scrollTo(n)}>{n}</div>
          ))}
        </div>
      )}

      {/* HERO */}
      <section id="home" className="hero-section">
        <div className="hero-inner">
          <div className="hero-left">
            <div className="hero-tag">
              <span className="hero-tag-line" />
              Available for opportunities
            </div>
            <h1 className="hero-name">
              Hi, I'm
              <span className="hero-name-accent">Praveen G</span>
            </h1>
            <div className="hero-role-line">
              <span className="role-divider" />
              <span>{typed}</span>
              <span className="cursor" />
            </div>
            <p className="hero-desc">
              Computer Science Engineering graduate specialising in Python, Django, and full-stack web development.
              I build scalable applications and intelligent systems that solve real problems.
            </p>
            <div className="hero-actions">
              <button className="btn-fill" onClick={() => scrollTo("projects")}>
                View Projects <IconArrowRight size={14} />
              </button>
              <a className="btn-ghost" href="/Praveen_G_CV.pdf" download>
                Download CV <IcoDownload size={14} />
              </a>
            </div>
            <div className="hero-chips">
              <span className="hero-chip"><IconLocation size={13} /> {DATA.location}</span>
              <span className="hero-chip"><IconMail size={13} /> {DATA.email}</span>
            </div>
          </div>

          <div className="hero-right">
            <CodingAnimation />
          </div>
        </div>

        <div className="hero-stats">
          {[
            { value: "3+",  label: "Projects Delivered" },
            { value: "74%", label: "Academic GPA"       },
            { value: "4+",  label: "Certifications"     },
            { value: "1",   label: "Internship"         },
          ].map(s => (
            <div key={s.label} className="stat-cell">
              <div className="stat-num">{s.value}</div>
              <div className="stat-desc">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" className="section s-white">
        <div className="inner">
          <div className="eyebrow"><span className="eyebrow-rule" />About Me</div>
          <h2 className="sec-title">Building software that <em>makes a difference</em></h2>
          <div className="about-layout">
            <div className="about-body">
              <p>I am a <strong>Computer Science Engineering graduate</strong> with a strong foundation in software development and modern web technologies.</p>
              <p>During my internship at <strong>AK Info Park Private Limited</strong>, I worked on a production Online Food Ordering System — designing responsive UI components and implementing dynamic content rendering.</p>
              <p>My goal is to grow as a <strong>Full Stack Developer</strong>, contributing to innovative products and modern software systems where I can make a measurable impact.</p>
              <div className="tag-row">
                {["Python", "Django", "Full Stack", "AI / ML", "MySQL", "React"].map(t => (
                  <span key={t} className="pill">{t}</span>
                ))}
              </div>
            </div>
            <div className="contact-card-box">
              {[
                { Icon: IconLocation, label: "Location", val: DATA.location,  href: null          },
                { Icon: IconMail,     label: "Email",    val: DATA.email,      href: `mailto:${DATA.email}` },
                { Icon: IconPhone,    label: "Phone",    val: DATA.phone,      href: `tel:${DATA.phone}`    },
                { Icon: IconLinkedIn, label: "LinkedIn", val: "linkedin.com/in/praveeng-profile", href: DATA.linkedin },
                { Icon: IconGithub,   label: "GitHub",   val: "https://github.com/Pravee004",            href: DATA.github   },
              ].map(({ Icon, label, val, href }) => (
                <div key={label} className="cc-row">
                  <div className="cc-icon"><Icon size={16} /></div>
                  <div className="cc-info">
                    <span className="cc-label">{label}</span>
                    <span className="cc-val">
                      {href
                        ? <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">{val}</a>
                        : val
                      }
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SKILLS */}
      <section id="skills" className="section s-cream">
        <div className="inner">
          <div className="eyebrow"><span className="eyebrow-rule" />Technical Skills</div>
          <h2 className="sec-title">Tools &amp; technologies I <em>work with</em></h2>
          <div className="skills-wrap">
            {DATA.skills.map(cat => (
              <div key={cat.title} className="sk-card">
                <div className="sk-head">{cat.title}</div>
                <div className="sk-items">
                  {cat.items.map(({ label, Icon }) => (
                    <div key={label} className="sk-item">
                      <Icon size={18} /><span>{label}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* INTERNSHIP */}
      <section id="internship" className="section s-white">
        <div className="inner">
          <div className="eyebrow"><span className="eyebrow-rule" />Experience</div>
          <h2 className="sec-title">Professional <em>experience</em></h2>
          <div className="exp-card">
            <div className="exp-header">
              <div>
                <div className="exp-role">{DATA.internship.role}</div>
                <div className="exp-company"><IconBriefcase size={14} /> {DATA.internship.company}</div>
                <div className="exp-loc"><IconLocation size={13} /> {DATA.internship.location}</div>
              </div>
              <div className="exp-period-badge">{DATA.internship.period}</div>
            </div>
            <div className="exp-body">
              <ul className="exp-points">
                {DATA.internship.points.map((p, i) => (
                  <li key={i} className="exp-point">
                    <span className="exp-bullet"><IconCheck size={11} /></span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* PROJECTS */}
      <section id="projects" className="section s-cream">
        <div className="inner">
          <div className="eyebrow"><span className="eyebrow-rule" />Project</div>
          <h2 className="sec-title">Selected <em>projects</em></h2>
          <div className="proj-grid">
            {DATA.projects.map(p => (
              <div key={p.title} className="proj-card">
                <div className="proj-card-top">
                  <div className="proj-num">{p.num}</div>
                  <h3 className="proj-title">{p.title}</h3>
                  <p className="proj-desc">{p.desc}</p>
                  <div className="proj-feats">
                    {p.features.map(f => (
                      <div key={f} className="proj-feat">
                        <IconCheck size={13} />{f}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="proj-card-foot">
                  {p.tech.map(t => <span key={t} className="tech-tag">{t}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EDUCATION */}
      <section id="education" className="section s-white">
        <div className="inner">
          <div className="eyebrow"><span className="eyebrow-rule" />Education</div>
          <h2 className="sec-title">Academic <em>background</em></h2>

          <div className="edu-wrap">
            {DATA.education.map(e => (
              <div key={e.degree} className="edu-card">
                <div className="edu-icon-cell"><IconGradCap size={20} /></div>
                <div>
                  <div className="edu-deg">{e.degree}</div>
                  <div className="edu-sch">{e.school}</div>
                  <div className="edu-loc"><IconLocation size={12} /> {e.location}</div>
                </div>
                <div className="edu-right">
                  <span className="edu-badge">{e.period}</span>
                  <span className="edu-score">{e.score}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="extras-row">
            <div className="extra-card">
              <div className="extra-head">Certifications</div>
              <div className="extra-list">
                {DATA.certifications.map(c => (
                  <div key={c} className="extra-item"><IconCheck size={14} /><span>{c}</span></div>
                ))}
              </div>
            </div>
            <div className="extra-card">
              <div className="extra-head">Courses</div>
              <div className="c-name">{DATA.course.name}</div>
              <div className="c-org">{DATA.course.org} &middot; {DATA.course.period}</div>
              <div className="c-topics">
                {DATA.course.topics.map(t => (
                  <span key={t} className="c-topic"><IconCheck size={11} />{t}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="section s-dark">
        <div className="inner">
          <div className="eyebrow"><span className="eyebrow-rule" />Get in Touch</div>
          <h2 className="sec-title">Open to <em>new opportunities</em></h2>
          <p className="contact-intro-text">
            I am actively looking for full-time roles and collaborative projects.
            Feel free to reach out — I respond promptly.
          </p>
          <div className="contact-cards">
            {[
              { Icon: IconMail,     label: "Email",    val: DATA.email,                         href: `mailto:${DATA.email}` },
              { Icon: IconPhone,    label: "Phone",    val: DATA.phone,                         href: `tel:${DATA.phone}`    },
              { Icon: IconLocation, label: "Location", val: DATA.location,                      href: null                   },
              { Icon: IconLinkedIn, label: "LinkedIn", val: "linkedin.com/in/praveeng-profile", href: DATA.linkedin          },
              { Icon: IconGithub,   label: "GitHub",   val: "github.com/Praveen004",            href: DATA.github            },
            ].map(({ Icon, label, val, href }) => (
              <a key={label}
                href={href || "#"}
                target={href?.startsWith("http") ? "_blank" : undefined}
                rel={href?.startsWith("http") ? "noopener noreferrer" : undefined}
                className="ct-item">
                <div className="ct-icon"><Icon size={19} /></div>
                <div className="ct-txt">
                  <span className="ct-label">{label}</span>
                  <span className="ct-val">{val}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <span className="footer-brand">Praveen G.</span>
        <span className="footer-note">Built with React.js &middot; {new Date().getFullYear()}</span>
        <div className="footer-socials">
          <a href={DATA.linkedin} target="_blank" rel="noopener noreferrer"><IconLinkedIn size={18} /></a>
          <a href={DATA.github}   target="_blank" rel="noopener noreferrer"><IconGithub   size={18} /></a>
        </div>
      </footer>
    </div>
  );
}